import { render, staticRenderFns } from "./UserScopeSelect.vue?vue&type=template&id=3e420ffc&"
import script from "./UserScopeSelect.vue?vue&type=script&lang=ts&"
export * from "./UserScopeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports